import { render, staticRenderFns } from "./SoCoursePreview.vue?vue&type=template&id=29daff1f&"
import script from "./SoCoursePreview.vue?vue&type=script&lang=js&"
export * from "./SoCoursePreview.vue?vue&type=script&lang=js&"
import style0 from "./SoCoursePreview.vue?vue&type=style&index=0&id=29daff1f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports